import {
  NavbarItem,
  NavbarLink,
  NavbarNav,
  NavbarNavCollapse,
  NavbarUserCollapse,
} from '@amzn/ring-ui-react-components';
import { useTranslation } from 'react-i18next';
import { useOpacityTransition } from 'src/hooks';
import { Icon } from 'src/shared/components/Icon';
import { useLocalizedNavConfig } from 'src/shared/hooks';
import { getLoginUrl } from 'src/utils';
import {
  NavbarBase,
  navbarNavCollapseTestProps,
  navbarUserCollapseTestProps,
  RingShopNavbarItem,
} from './NavbarBase';

// TODO: items on the left are aligned to the brand logo by eye, search for a better styling solution
export const UnauthenticatedNavbarDesktop = () => {
  const { t } = useTranslation(['components.navbar', 'common'], {
    useSuspense: false,
  });
  const transitionProps = useOpacityTransition();
  const { getTheApp, helpCenter, learnMore } = useLocalizedNavConfig();

  return (
    <NavbarBase>
      <NavbarNavCollapse
        {...navbarNavCollapseTestProps}
        ml={3}
        mr="auto"
        pt={{ m: 1 }}
      >
        <NavbarNav {...transitionProps}>
          <NavbarItem data-testid="get-the-app-nav-item">
            <NavbarLink href={getTheApp.url}>
              {t(getTheApp.labelKey ?? 'get-the-app')}
            </NavbarLink>
          </NavbarItem>
          <NavbarItem data-testid="learn-more-nav-item">
            <NavbarLink href={learnMore.url}>
              {t(learnMore.labelKey ?? 'learn-more')}
            </NavbarLink>
          </NavbarItem>
          <NavbarItem data-testid="help-center-nav-item">
            <NavbarLink href={helpCenter.url}>
              {t(helpCenter.labelKey ?? 'help-center')}
            </NavbarLink>
          </NavbarItem>
        </NavbarNav>
      </NavbarNavCollapse>
      <NavbarUserCollapse {...navbarUserCollapseTestProps} height="100%">
        <NavbarNav {...transitionProps}>
          <NavbarItem data-testid="log-in-nav-item">
            <NavbarLink href={getLoginUrl()} textStyle="footnote-xsmall-medium">
              <Icon
                aria-hidden="true"
                focusable="false"
                mb={1}
                name="account"
                size={20}
              />
              {t('login', { ns: 'common' })}
            </NavbarLink>
          </NavbarItem>
          <RingShopNavbarItem />
        </NavbarNav>
      </NavbarUserCollapse>
    </NavbarBase>
  );
};
